import { createSlice } from "@reduxjs/toolkit";
import { fetchModelsList, createOrUpdateModel, deleteModel } from "./modelsThunks";

const modelsSlice = createSlice({
  name: "models",
  initialState: {
    models: [],
    loading: false,
    error: null,
    successMessage: null,
    selectedModel: null,
    isEditModel: false,
  },
  reducers: {
    resetModelManageStatus: (state) => {
      state.successMessage = null;
    },
    setSelectedModel: (state, action) => {
      state.selectedModel = action.payload;
    },
    setIsEditModel: (state, action) => {
      state.isEditModel = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchModelsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchModelsList.fulfilled, (state, action) => {
        state.loading = false;
        state.models = action.payload;
      })
      .addCase(createOrUpdateModel.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(deleteModel.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      });
  },
});

export const { resetModelManageStatus, setSelectedModel, setIsEditModel } = modelsSlice.actions;
export default modelsSlice.reducer;
